<script lang="ts">
  import type { Snippet } from 'svelte';

  interface Props {
    open: boolean;
    title: string;
    onClose: () => void;
    closeOnBackdrop?: boolean;
    closeDisabled?: boolean;
    descriptionId?: string;
    children?: Snippet;
    footer?: Snippet;
  }

  let {
    open,
    title,
    onClose,
    closeOnBackdrop = true,
    closeDisabled = false,
    descriptionId,
    children,
    footer,
  }: Props = $props();

  function requestClose(): void {
    if (!closeDisabled) onClose();
  }

  function onBackdropClick(ev: MouseEvent): void {
    if (closeOnBackdrop && ev.target === ev.currentTarget) requestClose();
  }

  function onKey(ev: KeyboardEvent): void {
    if (open && ev.key === 'Escape') requestClose();
  }
</script>

<svelte:window onkeydown={onKey} />

{#if open}
  <div class="modal-backdrop" onclick={onBackdropClick} role="presentation">
    <div
      class="modal"
      role="dialog"
      aria-modal="true"
      aria-label={title}
      aria-describedby={descriptionId}
    >
      <header>
        <h3>{title}</h3>
        <button
          type="button"
          class="close"
          aria-label="閉じる"
          disabled={closeDisabled}
          onclick={requestClose}>×</button
        >
      </header>
      <div class="form-body">{@render children?.()}</div>
      {#if footer}<footer>{@render footer()}</footer>{/if}
    </div>
  </div>
{/if}

<style>
  .modal-backdrop {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    padding: 16px;
  }
  .modal {
    background: var(--panel, #ffffff);
    border-radius: var(--radius, 6px);
    width: 100%;
    max-width: 800px;
    max-height: 90vh;
    display: flex;
    flex-direction: column;
  }
  header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    border-bottom: 1px solid var(--border, #e3e6eb);
  }
  header h3 {
    margin: 0;
    font-size: 16px;
  }
  .close {
    background: none;
    border: none;
    font-size: 24px;
    color: var(--muted, #6b7280);
    cursor: pointer;
    line-height: 1;
  }
  .close:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  .form-body {
    overflow-y: auto;
    padding: 16px;
    flex: 1;
  }
  footer {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    padding: 12px 16px;
    border-top: 1px solid var(--border, #e3e6eb);
  }
</style>
